import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {Taxon} from "../../../domain/Taxon";

@Injectable()
export class TaxonHttpService extends AbstractHttpService<Taxon>{
    url = "/api/taxon";
}
